import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import holeOutPriceService from "./holeOutPriceService";

export const getHoleOutPrices = createAsyncThunk(
  "hole-out-price/get-hole-out-prices",
  async (params, thunkAPI) => {
    try {
      return await holeOutPriceService.getHoleOutPrices(params);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getHoleOutPrice = createAsyncThunk(
  "hole-out-price/get-hole-out-price",
  async (data, thunkAPI) => {
    try {
      return await holeOutPriceService.getHoleOutPrice(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createHoleOutPrice = createAsyncThunk(
  "hole-out-price/create-hole-out-price",
  async (data, thunkAPI) => {
    try {
      return await holeOutPriceService.createHoleOutPrice(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateHoleOutPrice = createAsyncThunk(
  "hole-out-price/update-hole-out-price",
  async (data, thunkAPI) => {
    try {
      return await holeOutPriceService.updateHoleOutPrice(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteHoleOutPrice = createAsyncThunk(
  "hole-out-price/delete-hole-out-price",
  async (data, thunkAPI) => {
    try {
      return await holeOutPriceService.deleteHoleOutPrice(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateHoleOutPriceStatus = createAsyncThunk(
  "customer/update-hole-out-price-status",
  async (data, thunkAPI) => {
    try {
      return await holeOutPriceService.updateHoleOutPriceStatus(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const initialState = {
  holeOutPrices: [],
  total: 0,
  priceEntryCount: 0,
  price: {},
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
  updating: false,
  isUpdateSuccess: false,
  creating: false,
  isCreateSuccess: false,
  isUpdateStatusSuccess: false,
};
export const holeOutPriceSlice = createSlice({
  name: "holeOutPrice",
  initialState,
  reducers: {
    initPrice: (state) => {
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = false;
      state.message = "";
      state.updating = false;
      state.isUpdateSuccess = false;
      state.creating = false;
      state.isCreateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getHoleOutPrices.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getHoleOutPrices.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.prices = action.payload.prices;
        state.total = action.payload.priceCount;
        state.isCreateSuccess = false;
        state.isUpdateSuccess = false;
      })
      .addCase(getHoleOutPrices.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createHoleOutPrice.pending, (state, action) => {
        state.creating = true;
        state.isCreateSuccess = false;
      })
      .addCase(createHoleOutPrice.rejected, (state, action) => {
        state.isError = true;
        state.creating = false;
        state.message = action.payload.response.data.message[0];
      })
      .addCase(createHoleOutPrice.fulfilled, (state, action) => {
        state.price = action.payload;
        state.creating = false;
        state.isCreateSuccess = true;
      })
      .addCase(updateHoleOutPrice.pending, (state, action) => {
        state.updating = true;
        state.isUpdateSuccess = false;
      })
      .addCase(updateHoleOutPrice.rejected, (state, action) => {
        state.isError = true;
        state.message = action.payload.response.data.message[0];
        state.updating = false;
      })
      .addCase(updateHoleOutPrice.fulfilled, (state, action) => {
        state.price = action.payload;
        state.updating = false;
        state.isUpdateSuccess = true;
      })
      .addCase(updateHoleOutPriceStatus.pending, (state, action) => {
        state.updating = true;
        state.isUpdateStatusSuccess = false;
        const { id, data } = action.meta.arg;
        state.prices = state.prices.map((customer) =>
          customer.id === id ? { ...customer, ...data } : customer);
      })
      .addCase(updateHoleOutPriceStatus.rejected, (state, action) => {
        state.isError = true;
        state.updating = false;
        state.message = action.payload.response.data.message[0];
      })
      .addCase(updateHoleOutPriceStatus.fulfilled, (state, action) => {
        state.updating = false;
        state.isUpdateStatusSuccess = true;
      })

      .addCase(deleteHoleOutPrice.pending, (state, action) => {
        state.updating = true;
        state.isUpdateStatusSuccess = false;
      })
      .addCase(deleteHoleOutPrice.rejected, (state, action) => {
        state.isError = true;
        state.updating = false;
        state.message = action.payload.response.data.message[0];
      })
      .addCase(deleteHoleOutPrice.fulfilled, (state, action) => {
        state.updating = false;
        state.isUpdateStatusSuccess = true;
        // Assuming action.payload contains the id of the deleted price
        const deletedId = action.meta.arg.id; // Or whatever your payload structure is    
        // Remove the price from the state
        state.holeOutPrices = state.holeOutPrices.filter(
          (customer) => customer.id !== deletedId
        );
      })

      .addCase(getHoleOutPrice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getHoleOutPrice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.price = action.payload;
      })
      .addCase(getHoleOutPrice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
  },
});
export default holeOutPriceSlice.reducer;
export const { initPrice } = holeOutPriceSlice.actions;